import type { ReactNode } from "react";

export interface TileGridProps {
  className?: string;
  children?: ReactNode;
}

/**
 * The responsive auto-fit grid that lays {@link Tile}s out with uniform spacing — the
 * `fui-tile-grid` vocabulary. Presentational: it owns only the grid tracks + the gap between
 * tiles (and stretches each row so tiles share a height). Ordering, show/hide and drag live in
 * {@link TileBoard}. Use it standalone for a static tile dashboard, or let TileBoard render it.
 */
export function TileGrid({ className, children }: TileGridProps) {
  return <div className={className ? `fui-tile-grid ${className}` : "fui-tile-grid"}>{children}</div>;
}
